var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-impl"},[_c('login-panel',{staticClass:"login-panel"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_vm._v(" 大连金力得科技发展有限公司"),_c('br'),_vm._v(" Copyright@2020 Amazon4Sellers Team. All rights reserved. ")])
}]

export { render, staticRenderFns }